module.exports = __webpack_public_path__ + "img/usa-main-logo.8207a572.jpg";